import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import TopBar from "./TopBar";
import ProcessingQueue from "../users/ProcessingQueue";
import api from "../api"; // adjust path if needed

const DEFAULT_AI_PREFERENCES = {
  //LENGTH_OPTIONS
  tone: "Default",
  length: "long",
  aiRole: "Default",
  userRole: "Default",
};

const MainLayout1 = () => {
  const token = localStorage.getItem("access_token");

  const [isSearchActive, setIsSearchActive] = useState(false);
  const [isKnowledgeSearchActive, setIsKnowledgeSearchActive] =
    useState(false);

  const [uploadedDocNames, setUploadedDocNames] = useState([]);

  const [aiPreferences, setAiPreferences] = useState(() => {
    const stored = localStorage.getItem("aiPreferences");
    return stored ? JSON.parse(stored) : DEFAULT_AI_PREFERENCES;
  });

  const [sidebarExpanded, setSidebarExpanded] = useState(() => {
    const storedState = localStorage.getItem("sidebarExpanded");
    if (storedState !== null && window.innerWidth > 768) {
      return JSON.parse(storedState);
    }
    return window.innerWidth > 768;
  });

  // ================================
  // ✅ FETCH USER PREFERENCES (IMPORTANT)
  // ================================
  const fetchPreferences = async () => {
    try {
      const res = await api.get(
        `${process.env.REACT_APP_API_URL}/user-profile/preferences`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = res.data;



      if (data?.preferences) {
        const prefs = data.preferences;


        console.log("Fetched preferences****:", prefs);

        // 🔥 Sync toggle states
        setIsSearchActive(
          prefs.chat?.web_search_enabled ?? false
        );

        setIsKnowledgeSearchActive(
          prefs.chat?.knowledge_search_enabled ?? false
        );
      }

      // 🎨 Apply theme
      if (data?.theme_mode) {
        const isDark = data.theme_mode === "dark";
        localStorage.setItem("darkMode", isDark);
        document.documentElement.setAttribute(
          "data-theme",
          isDark ? "dark" : "light"
        );
      }

    } catch (err) {
      console.error("❌ Error fetching preferences:", err);
    }
  };

  useEffect(() => {
    if (token) {
      fetchPreferences();
    }
  }, [token]);

  // ================================
  // Sidebar Resize Logic
  // ================================
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setSidebarExpanded(false);
      } else {
        const stored = localStorage.getItem("sidebarExpanded");
        setSidebarExpanded(stored ? JSON.parse(stored) : true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Persist AI preferences
  useEffect(() => {
    localStorage.setItem("aiPreferences", JSON.stringify(aiPreferences));
  }, [aiPreferences]);

  // Persist sidebar state on desktop only
  useEffect(() => {
    if (window.innerWidth > 768) {
      localStorage.setItem(
        "sidebarExpanded",
        JSON.stringify(sidebarExpanded)
      );
    }
  }, [sidebarExpanded]);

  const resetAiPreferences = () => {
    setAiPreferences(DEFAULT_AI_PREFERENCES);
  };

  return (
    <div className="app">
      <Sidebar
        expanded={sidebarExpanded}
        toggleSidebar={() => setSidebarExpanded(!sidebarExpanded)}
      />

      <div
        className={`main-content-wrapper ${
          sidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <nav className="topbar-wrapper">
          <TopBar
            sidebarExpanded={sidebarExpanded}
            toggleSidebar={() => setSidebarExpanded(!sidebarExpanded)}
            isSearchActive={isSearchActive}
            setIsSearchActive={setIsSearchActive}
            isKnowledgeSearchActive={isKnowledgeSearchActive}
            setIsKnowledgeSearchActive={setIsKnowledgeSearchActive}
          />
        </nav>

        <main className="page-content">
          <Outlet
            context={{
              isSearchActive,
              setIsSearchActive,
              isKnowledgeSearchActive,
              setIsKnowledgeSearchActive,
              uploadedDocNames,
              setUploadedDocNames,
              aiPreferences,
              setAiPreferences,
              resetAiPreferences,
              DEFAULT_AI_PREFERENCES,
            }}
          />
        </main>

        <ProcessingQueue />
      </div>
    </div>
  );
};

export default MainLayout1;
